import { Modal, Slider } from 'antd';
import Cropper from 'react-easy-crop';
import { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';

import BRButton from 'components/BRButton/BRButton';

const CroppingModal = ({
  close,
  setCroppedImage,
  setLoading,
  imageUrl,
  loading,
  file,
  ...rest
}) => {
  const intl = useIntl();

  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(2);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  function getCroppedImg(imageSrc, crop, zoom, aspect = 1) {
    return new Promise((resolve, reject) => {
      const image = new window.Image();
      image.crossOrigin = 'anonymous';
      image.src = imageSrc;
      image.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        canvas.width = crop.width;
        canvas.height = crop.height;
        ctx.drawImage(
          image,
          crop.x,
          crop.y,
          crop.width,
          crop.height,
          0,
          0,
          crop.width,
          crop.height
        );
        canvas.toBlob((blob) => {
          if (!blob) {
            reject(new Error('Canvas is empty'));
            return;
          }
          resolve({ blob });
        }, 'image/jpeg');
      };
      image.onerror = reject;
    });
  }

  const handleSave = async () => {
    setLoading(true);
    try {
      const { blob } = await getCroppedImg(imageUrl, croppedAreaPixels, zoom);
      setCroppedImage(blob, file);
      close();
    } catch (e) {}
    setLoading(false);
  };

  const onCropComplete = useCallback((_, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  return (
    <Modal
      {...rest}
      onCancel={close}
      footer={null}
      closable={true}
      title={intl.formatMessage({ id: 'avatar_upload.cropping_modal_title' })}
      centered
      width={400}
      className="br-avatar-upload__modal"
    >
      <div className="br-avatar-upload__cropper-wrapper">
        {imageUrl && (
          <Cropper
            key={imageUrl}
            image={imageUrl}
            crop={crop}
            zoom={zoom}
            aspect={1}
            restrictPosition={true}
            cropShape="round"
            showGrid={false}
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={onCropComplete}
          />
        )}
        <div className="br-avatar-upload__slider-wrapper">
          <span className="br-avatar-upload__slider-label heading2">
            {intl.formatMessage({ id: 'avatar_upload.zoom' })}
          </span>
          <div className="br-avatar-upload__slider-container">
            <Slider
              min={1}
              max={3}
              step={0.01}
              value={zoom}
              onChange={setZoom}
              className="br-avatar-upload__slider"
            />
            <span className="br-avatar-upload__zoom-percentage label_sm">
              {Number(zoom * 100).toFixed(0)}%
            </span>
          </div>
        </div>
      </div>

      <div className="br-avatar-upload__modal-footer">
        <BRButton
          type="primary"
          loading={loading}
          onClick={handleSave}
          label={intl.formatMessage({ id: 'avatar_upload.save' })}
        />
      </div>
    </Modal>
  );
};

export default CroppingModal;
